import { KeyDateType } from "@models/keyDate.model"
import { httpRequest } from "../../http"

export class CommandGetKeyDateTypes {
    async run() {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/key-date-types/`
        try {
            const response = await httpRequest<KeyDateType[]>(url, { method: "GET" })
            return response
        } catch (error) {
            console.error('Error fetching data:', error)
            throw error
        }
    }
}
